var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmsPush = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "2a",
    width: 80,
    height: 80,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M80 0H0v80h80z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.7764 78.533c19.0836 0 34.5538-8.5236 34.5538-19.038S53.86 40.457 34.7764 40.457C15.693 40.457.2227 48.9806.2227 59.495S15.693 78.533 34.7764 78.533",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m48.3274 4.0605-4.4503-3.05s-.7489-.6296-1.8994-.0543C40.838 1.5423 22.299 12.3314 22.299 12.3314s-3.5275 1.5196-3.5275 5.1557.0868 51.4814.0868 51.4814 0 1.2699.9986 1.856c.9443.5427 4.5805 1.943 5.4271 2.0949.6621.1194 1.4218-.4993 1.4218-.4993s-1.5087.9117-2.5072-.076c-.521-.521-.3799-1.8452-.3799-2.6484l.0108-49.8967s.0542-3.2453 2.9415-4.5913c2.8872-1.3459 20.0042-11.1798 20.0042-11.1798s.7815-.4667 1.5522.0326Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M23.8296 71.3023v-51.286c0-1.9538 1.0528-3.7447 2.7569-4.6998L46.7753 4.0281c1.0203-.5753 2.2794.1737 2.2685 1.335l-.2388 51.8614c-.0108 1.3893-.7489 2.67-1.9428 3.3647L26.2501 72.6916c-1.0746.6295-2.4205-.1411-2.4205-1.3893Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    stroke: "#0061AF",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "m29.2773 13.8075 1.2374.8358c.5319.3581 1.2156.3908 1.7692.0759l8.1732-4.6238c.6295-.3582 1.0746-.977 1.2048-1.6933l.3039-1.6824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32.8279 13.2324-.076-.1411c-.0651-.1194-.0217-.2604.0977-.3256l6.5234-3.5601c.1194-.0652.2605-.0218.3256.0976l.076.1411c.0651.1195.0217.2606-.0977.3257l-6.5234 3.5601c-.1194.0652-.2605.0217-.3256-.0977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    d: "M20.334 26.344v-4.5587c0-.4451.3691-.8141.814-.8141.4451 0 .8141.369.8141.8141v4.5587c0 .445-.369.8141-.8141.8141-.4558 0-.814-.3691-.814-.8141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.334 33.3449v-4.5587c0-.445.3691-.814.814-.814.4451 0 .8141.369.8141.814v4.5587c0 .4451-.369.8141-.8141.8141-.4558 0-.814-.369-.814-.8141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    d: "M68.0502 28.6514H39.0064c-1.5782 0-2.8575 1.2793-2.8575 2.8574v22.8843c0 1.5781 1.2793 2.8574 2.8575 2.8574h29.0438c1.5781 0 2.8574-1.2793 2.8574-2.8574V31.5088c0-1.5781-1.2793-2.8574-2.8574-2.8574Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M42.0005 48.2161V37.8086c0-.9956.8145-1.8101 1.81-1.8101h19.0051c.9955 0 1.81.8145 1.81 1.8101v10.4075c0 .9956-.8145 1.8101-1.81 1.8101H43.8105c-.9955 0-1.81-.8145-1.81-1.8101Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    d: "m43.3667 36.0801 9.7741 7.964c.2896.2353.6969.2353.9864-.009l9.2311-7.7107"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m43.3667 36.0801 9.7741 7.964c.2896.2353.6969.2353.9864-.009l9.2311-7.7107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M70.6867 37.451c4.252 0 7.699-3.4469 7.699-7.6989s-3.447-7.6989-7.699-7.6989-7.6989 3.4469-7.6989 7.6989 3.4469 7.6989 7.6989 7.6989Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.793 33.2715v-5.1901l-1.1171.7954-.7482-1.2329 2.0445-1.412h1.4753v7.0396z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmsPush);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms-push.b631294c689e48abff8f90ce5346c556.svg";